import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-page-loader',
  templateUrl: './user-page-loader.component.html',
  styleUrl: './user-page-loader.component.scss',
  standalone: false
})
export class UserPageLoaderComponent {
  @Input() label = 'Loading';
}